import {useGSAP} from '@gsap/react'
import gsap from 'gsap'
import {memo, useRef} from 'react'

interface WaveItemProps {
  onComplete: () => void
}

export const WaveItem = memo(
  ({onComplete}: WaveItemProps) => {
    const wareRef = useRef<HTMLDivElement>(null)

    useGSAP(() => {
      const timeline = gsap.timeline({paused: false})

      timeline.set(wareRef.current, {
        scale: 0,
      })

      timeline.to(wareRef.current, {
        scale: 1,
        duration: 0.5,
      })

      timeline.to(wareRef.current, {
        opacity: 0,
        duration: 0.2,
        onComplete,
      })
    })

    return (
      <div ref={wareRef} className="absolute h-full w-full rounded-full bg-slate-300 opacity-10" />
    )
  },
  () => true,
)
